import React from 'react';
import { useForm } from "react-hook-form"
import '../App.css'
import axios from "axios"
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate } from 'react-router-dom';
function ForgotPassword({ IP }) {
    const navigate = useNavigate()
    const { register, handleSubmit, formState: { errors } } = useForm();

    const ResetPassword = async (resetData) => {
        await axios.post(`http://${IP}/reset-student-password`, resetData)
            .then((response) => {
                if (response.data.msg == "Password Reset Successfull") {
                    notifySuccess(response.data.msg)
                }
                else if (response.data.msg == "Invalid Details") {
                    notifyError(response.data.msg)
                }
            })
            .catch((error) => {
                console.log(error);
            });
    }

    const notifySuccess = (msg) =>
        toast.success(msg, {
            position: "top-center",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        });


    const notifyError = (msg) =>
        toast.error(msg, {
            position: "top-center",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        });

    return (
        <div className='row col-lg-4 col-md-6 col-sm-8 col-xs-11 m-auto'>
            <form className='form mt-5 m-auto mb-2' onSubmit={handleSubmit(ResetPassword)}>

                <h1 className='reset-text'>RESET</h1>

                <div className='form-group'>
                    <label htmlFor="rno"><small>Username</small></label>
                    <input type="text" id="rno" className="form-control" placeholder="username" {...register("username", { required: true })} />
                    {errors.username && <span className='text-danger'>*Username is required</span>}
                </div>

                <div className='form-group'>
                    <label htmlFor="pass"><small>Passcode</small></label>
                    <input type="password" id="pass" className="form-control" placeholder="passcode" {...register("passcode", { required: true })} />
                    {errors.passcode && <span className='text-danger'>*Passcode is required</span>}
                </div>

                <div className='form-group'>
                    <label htmlFor="pass1"><small>New password</small></label>
                    <input type="password" id="pass1" className="form-control" placeholder="password" {...register("password", { required: true, minLength: 8 })} />
                    {errors.password?.required && <span className='text-danger'>*Password is required</span>}
                    {errors.password?.minLength && <span className='text-danger'>*Minimum length should be 8</span>}
                </div>

                <div className="">
                    <span><a href='/'><small>Back to login</small></a></span>
                </div>

                <div className='form-group'>
                    <button className='btn btn-primary w-100 reset-button'>Reset</button>
                </div>
            </form>
            <ToastContainer
                position="top-center"
                autoClose={3000}
                hideProgressBar={true}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
        </div>
    );
}

export default ForgotPassword;